import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { ButtonTypeEnum } from '@panaya/ui/p-button';

@Component({
    selector: 'common-grid-footer',
    template: `
        <div class="common-footer" automation-id="common-grid-footer-id">
            <span class="footer-left-side" [ngClass]="isReloadEnabled ? 'common-grid-footer-small-margin' : 'common-grid-footer-margin'">
                <ng-content></ng-content>
            </span>
            <span class="footer-right-side" [ngClass]="isReloadEnabled ? 'common-grid-footer-small-margin' : 'common-grid-footer-margin'">
                <span *ngIf="isSelectEnable" class="p-paragraph-2">
                    {{ selectedItemsMessage | translate: { totalSelected: totalSelected } }}
                </span>

                <span *ngIf="totalEntities !== 1" class="common-footer-items p-paragraph-2" automation-id="footer-grid-show">
                    {{ totalItemsMessage | translate: { totalItems: totalEntities || 0 } }}
                </span>
                <span *ngIf="totalEntities === 1" class="common-footer-items p-paragraph-2" automation-id="footer-grid-show">
                    {{ oneItemMessage | translate }}
                </span>
                <span *ngIf="!isReloadEnabled" class="common-footer-no-reload"></span>

                <p-button
                    *ngIf="isReloadEnabled"
                    class="common-footer-refresh"
                    ariaLabel="Refresh"
                    [buttonType]="buttonType.IsIcon"
                    iconBefore="refresh-cw"
                    iconBeforeSize="sm"
                    [matTooltip]="'Actions.refresh' | translate"
                    matTooltipPosition="above"
                    (buttonClicked)="reloadRows.emit()"
                ></p-button>
            </span>
        </div>
    `,
    styleUrls: ['./common-grid-footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CommonGridFooterComponent implements OnInit {
    @Input() totalSelected?: number;
    @Input() totalEntities?: number;
    @Input() isSelectEnable: boolean = false;
    @Input() isReloadEnabled: boolean = false;
    @Input() selectedItemsMessage: string = 'gridFilters.selectedItemsMessage';
    @Input() oneItemMessage: string = 'gridFilters.oneItemMessage';
    @Input() totalItemsMessage: string = 'gridFilters.totalItemsMessage';

    @Output()
    reloadRows = new EventEmitter();

    public buttonType = ButtonTypeEnum;

    constructor() {}

    ngOnInit(): void {}
}
